import * as React from 'react';
import { Cross } from '@sravni/react-icons';
import { useStyles } from '@sravni/react-utils';
import { Icon } from '../../Icon/src/Icon.js';
import { Space } from '../../Space/src/Space.js';
import modules_a8333fe4 from '../styles/Alert.module.less.js';

/**
 * @description The Alert component is used to show feedback to the user about an action or state
 *
 * @component
 * @example
 * ```jsx
 * <Alert icon={icon} title="Информационный заголовок" message="Информационное сообщение" />
 * ```
 */
const Alert = React.forwardRef((props, ref) => {
    const { title, subtitle, icon, variant = 'secondary', color = 'dark', footer, closable, onClose, className, children, ...restProps } = props;
    const cx = useStyles(modules_a8333fe4);
    const classNames = cx(className, 'container', {
        [`color-${color}-${variant}`]: true,
    });
    return (React.createElement("div", { ref: ref, "data-qa": "Alert", className: classNames, ...restProps },
        (!!icon || !!title || !!subtitle) && (React.createElement(Space, { size: 12, align: "center", className: cx('header') },
            icon && React.createElement("div", { className: cx('icon') }, icon),
            React.createElement(Space, { direction: "vertical", size: 0, className: cx('title-wrapper') },
                title && React.createElement("div", { className: cx('title') }, title),
                subtitle && React.createElement("div", { className: cx('subtitle') }, subtitle)),
            closable && React.createElement(Icon, { className: cx('close'), icon: React.createElement(Cross, null), onClick: onClose }))),
        children && (React.createElement(Space, null,
            React.createElement("div", { className: cx('content') }, children),
            closable && !title && !subtitle && React.createElement(Icon, { className: cx('close'), icon: React.createElement(Cross, null), onClick: onClose }))),
        footer && (React.createElement(Space, { size: 12, justify: "stretch", className: cx('footer') }, footer))));
});
Alert.displayName = 'Alert';

export { Alert };
//# sourceMappingURL=Alert.js.map
